module.exports = __webpack_public_path__ + "64440ff2983ff2fc34d469e10783bd09.svg";